import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../../../utils';
import AddPassengerForm from '../../../../../AddPassenger/components/AddPassengerForm/AddPassengerForm';
import { PassengerState } from '../GroupOrder';
import SlideBottom from '../../../../../SlideBottom/components/SlideBottom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';

interface Props {
	onAddPassenger: (lastName: string, id: string, internalId?: string) => Promise<boolean>;
	passenger?: PassengerState;
	isOpen?: boolean;
}

const AddPassengerWrapper: React.FC<Props> = props => {
	const [open, setOpen] = React.useState(props.isOpen || false);
	const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });

	const { t } = useTranslation('Checkout');
	const theme = useTheme('Checkout').GroupOrder;

	const onLabelClick = (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();
		e.preventDefault();

		setOpen(true);
	};

	const initialValues = props.passenger
		? {
				lastName: props.passenger.passengerName,
				id: props.passenger.passengerId
		  }
		: null;

	return open && !isMobile ? (
		<div className={theme.editPassenger}>
			<AddPassengerForm
				onSubmit={(lastName, id) => {
					return props.onAddPassenger(lastName, id, props.passenger?.id);
				}}
				onSuccess={() => setOpen(false)}
				initialValues={initialValues}
				hideIcon={true}
				buttonText={t(props.passenger ? 'Done' : 'Add')}
				validationType="ticketNumber"
			/>
		</div>
	) : (
		<>
			{isMobile && (
				<SlideBottom isOpen={open} onClose={() => setOpen(false)}>
					<AddPassengerForm
						onSubmit={(lastName, id) => {
							return props.onAddPassenger(lastName, id, props.passenger?.id);
						}}
						onSuccess={() => setOpen(false)}
						initialValues={initialValues}
						hideIcon={true}
						buttonText={t(props.passenger ? 'Done' : 'Add')}
						validationType="ticketNumber"
					/>
				</SlideBottom>
			)}

			<div onClick={onLabelClick}>{props.children}</div>
		</>
	);
};

export default AddPassengerWrapper;
